var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.298,
    height: 109.154,
    viewBox: "0 0 153.298 109.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TV-ic",
    transform: "translate(-3703 3097.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M3703-3008.855v-85.034c1.109-2.562,3.048-3.394,5.822-3.39q70.828.089,141.656,0c2.778,0,4.709.833,5.819,3.391v85.034c-1.005,2.65-2.97,3.556-5.735,3.547-17.665-.058-35.329-.029-52.994-.029h-1.933v8.2c4.006,0,7.9-.043,11.787.013,3.573.051,5.763,3.367,4.283,6.421-.939,1.936-2.58,2.581-4.664,2.578q-27.395-.037-54.79-.015c-.3,0-.6,0-.9-.017a4.48,4.48,0,0,1-4.191-3.975,4.4,4.4,0,0,1,3.241-4.761,8.763,8.763,0,0,1,2.215-.236c3.675-.022,7.351-.01,11.084-.01v-8.2h-1.971c-17.665,0-35.33-.029-52.994.029C3705.973-3005.3,3704.006-3006.2,3703-3008.855Zm9.1-79.305v73.726h135.124v-73.726Zm60.782,82.91v8.018h13.569v-8.018Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvIc);
export default __webpack_public_path__ + "static/media/TV-ic.5d21337049082226b69ddd1a2979e5e3.svg";
export { ForwardRef as ReactComponent };